/* eslint-disable compat/compat */
// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'

class FeaturedCardsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.els.slides.element.classList.add('keen-slider')

    this.els.slide.elements.forEach(el =>
      el.classList.add('keen-slider__slide'),
    )

    this.els.next.element.addEventListener('click', e => {
      this.carousel.next()
    })

    this.els.prev.element.addEventListener('click', e => {
      this.carousel.prev()
    })

    this.carousel = this.initialiseCarousel()

    this.carousel.on('slideChanged', () => {
      this.els.next.element.disabled =
        this.carousel.track.details.maxIdx === this.carousel.track.details.rel

      this.els.prev.element.disabled = this.carousel.track.details.rel === 0
    })
  }

  useCurrentSlideIndicator = (indicator, template = '{{ current }}') => {
    /** @param {KeenSliderInstance} carousel */
    return carousel => {
      const updateIndicator = () => {
        const { rel, maxIdx } = carousel.track.details
        const current = String(rel + 1)
        const total =
          maxIdx === Infinity ? carousel.slides.length : String(maxIdx + 1)
        indicator.textContent = window.BAO.Utils.translateString(template, {
          current,
          total,
        })
      }

      carousel.on('created', updateIndicator)
      carousel.on('slideChanged', updateIndicator)
    }
  }

  useDots = (dots = []) => {
    /** @param {KeenSliderInstance} carousel */
    return carousel => {
      const updateDotStates = () => {
        dots.forEach((dot, index) => {
          const isCurrent = carousel.track.details.rel === index

          dot.setAttribute('aria-current', String(isCurrent))
        })
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          carousel.moveToIdx(index)
        })
      })

      carousel.on('created', updateDotStates)
      carousel.on('slideChanged', updateDotStates)
    }
  }

  initialiseCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        breakpoints: {
          '(min-width: 768px)': {
            slides: { perView: 3, spacing: 11 },
          },
        },
        slides: {
          perView: 1.2,
          spacing: 10,
        },
        loop: true,
      },
      [
        this.useCurrentSlideIndicator(
          this.els.totalPage.element,
          '{{ current }}/{{ total }}',
        ),
        this.useDots(this.els.dot.elements),
      ],
    )
  }

  get totalPages () {
    return Math.ceil(this.slideCount / 3)
  }

  get slideCount () {
    return this.els.slide.elements.length
  }
}

if (!customElements.get('featured-cards-carousel')) {
  customElements.define('featured-cards-carousel', FeaturedCardsCarousel)
}
